<template>
    <div v-if="isStaff" class="staffBanner">
        <div v-if="isMockPublisherChat" class="staffBannerText">
            <div class="staffModeBannerHeader">Publisher Mode</div>
            <div class="staffModeBannerSubHeader">chatting as {{ publisherEmail }}</div>
        </div>
        <div v-else class="staffBannerText">
            <div class="staffModeBannerHeader">Staff Mode</div>
            <div class="staffModeBannerSubHeader">escalation unavailable</div>
        </div>
    </div>

</template>
<script>
    import { mapGetters } from "vuex";
    export default {
        name: 'StaffChatBanner',
        computed: {
            ...mapGetters([
                "user",
                "isMockPublisherChat",
            ]),
            isStaff() {
                return this.user && this.user.userType === "contributor"
            },
            publisherEmail() {
                return this.user.userEmail;
            }
        },
    }
</script>

<style scoped>
.staffBanner {
    padding: 2px 8px;
    background-color: #2f5312;
    color: #ffffff;
    position: sticky;
    top: 0;
    z-index: 2;
}

.staffBannerText {
    display: flex;
    justify-content: space-between;
}

.staffBanner .staffModeBannerHeader {
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 600;
}

.staffBanner .staffModeBannerSubHeader {
    font-size: 12px;
    font-weight: 300;
}

</style>